import React, { useState } from 'react';
import { Send } from 'lucide-react';

const MessageInput = ({ onSendMessage, disabled = false }) => {
    const [message, setMessage] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (message.trim() && !disabled) {
            onSendMessage(message.trim());
            setMessage('');
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmit(e);
        }
    };

    return (
        // <div className="px-4 sm:px-6 py-2 sm:py-3 bg-dark-secony border-t border-dark-border">
        <div className="px-4 sm:px-6 py-2 sm:py-3">
            <form onSubmit={handleSubmit} className="max-w-3xl mx-auto">
                <div className="relative flex items-center">
                    <div className="flex-1 relative">
                        <input
                            type="text"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            // onKeyPress={handleKeyPress}
                            onKeyDown={handleKeyPress}
                            placeholder="Send a message..."
                            disabled={disabled}
                            className="w-full px-3 sm:px-4 py-2 sm:py-2.5 pr-10 sm:pr-12 bg-dark-bg border border-dark-border rounded-lg 
                       text-white placeholder-gray-400 focus:outline-none focus:border-blue-500 
                       focus:ring-1 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed
                       transition-colors text-sm sm:text-base"
                        />
                        <button
                            type="submit"
                            disabled={!message.trim() || disabled}
                            className="absolute right-1.5 sm:right-2 top-1/2 transform -translate-y-1/2 
                       p-1.5 sm:p-2 text-gray-400 hover:text-white disabled:opacity-50 
                       disabled:cursor-not-allowed transition-colors"
                        >
                            <Send size={16} className="sm:w-[18px] sm:h-[18px]" />
                        </button>
                    </div>
                </div>
            </form>

            {/* Note en bas - taille réduite */}
            <p className="text-[10px] sm:text-xs text-gray-500 text-center mt-1.5 sm:mt-2 max-w-4xl mx-auto">
                Lamien Lite may provide inaccurate information and does not provide investment advice.
                Responses may be slow during peak times.
            </p>
        </div>
    );
};

export default MessageInput;